import React from 'react'
import FloaterGUI from '../../components/floaterGUI/FloaterGUI'


import './floater.css'

const Floater = () => {
  return (
    <div className='floater'>
      <FloaterGUI />
    </div>
  )
}

export default Floater
